<template>
    <b-modal :id="'modal-visualizar-descricao-arquivo-' + arquivo.id" hide-footer centered title="Descrição Do Arquivo">
        <div>
        <p style="text-align: justify;">{{ arquivo.descricao }}</p>
        </div>
        <div class="d-flex mt-5">
            <b-button variant="outline-success" class="mx-auto" @click="$bvModal.hide('modal-visualizar-descricao-arquivo-' + arquivo.id)">
						OK
            </b-button>
        </div>

    </b-modal>
</template>

<script>

export default {
	name: "ModalVisualizarDescricaoArquivo",
	props: [ "arquivo" ],
};
</script>



// WEBPACK FOOTER //
// src/components/Arquivos/ModalVisualizarDescricaoArquivo.vue